export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVR42mP8z8DwnwEHAAcDx/9t9QAAAAAASUVORK5CYII="